import { IScrollList } from '../interfaces/scrollList';

export const scrollListData: IScrollList[] = [
    { countRegister: 200000, exploreBtn: 'Xem lộ trình', href: '/learning-paths/', heading: 'Khóa học miễn phí' },
    { exploreBtn: 'Xem tất cả', href: '/blog', heading: 'Bài viết nổi bật' },
    {
        exploreBtn: 'Xem tất cả',
        href: 'https://www.youtube.com/c/F8VNOfficial/videos?view=0&amp;sort=p&amp;flow=grid',
        heading: 'Videos nổi bật',
    },
];
